import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
export var User = /*#__PURE__*/function () {
  function User(id, accounts, email, emailVerified, phone, phoneNumberVerified) {
    _classCallCheck(this, User);

    this.id = id;
    this.accounts = accounts;
    this.email = email;
    this.emailVerified = emailVerified;
    this.phoneNumber = phone;
    this.phoneNumberVerified = phoneNumberVerified;
  }

  _createClass(User, [{
    key: "toStorageString",
    value: function toStorageString() {
      return JSON.stringify({
        accounts: this.accounts,
        email: this.email,
        emailVerified: this.emailVerified,
        id: this.id,
        phoneNumber: this.phoneNumber,
        phoneNumberVerified: this.phoneNumberVerified
      });
    }
  }], [{
    key: "fromJson",
    value: function fromJson(json) {
      return new User(json.sub, json.accounts, json.email, json.email_verified, json.phone_number, json.phone_number_verified);
    }
  }, {
    key: "fromString",
    value: function fromString(s) {
      var parsed;

      try {
        parsed = JSON.parse(s);
      } catch (e) {
        return;
      }

      if (parsed.id) {
        return new User(parsed.id, parsed.accounts, parsed.email, parsed.emailVerified, parsed.phoneNumber, parsed.phoneNumberVerified);
      }

      return;
    }
  }]);

  return User;
}();